import React, { useState, useEffect } from 'react'
import { BiPlusMedical, BiSearchAlt } from 'react-icons/bi';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { getInstitutions, getRoles } from '../../services/http';
import CustomDatatableInstitution from '../../components/CustomDatatableInstitution/CustomDatatableInstitution';
import { handleMenuSelection, handleSubMenuSelection, searchFunction, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import "./RoleList.css"
import CustomDatatableRole from '../../components/CustomDatatableRole/CustomDatatableRole';

const RoleList = () => {

  const [displayLoader, setDisplayLoader] = useState(true);
  const tableColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Role" },
    { id: "3", label: "Permissions" }
  ]

  const fakeDate = [
    {
      id: "1", label: "Staff", permissions: [
        { id: "1", label: "Ajouter Institution" },
        { id: "2", label: "Ajouter Produit" }
      ],
      showDelete: false
    },
    {
      id: "2", label: "Admin", permissions: [
        { id: "1", label: "Ajouter Institution" },
        { id: "2", label: "Ajouter Produit" },
        { id: "3", label: "Ajouter Catégorie Produit" },
        { id: "4", label: "Ajouter Catégorie d'Institution" },
        { id: "5", label: "Ajouter Agent" }
      ],
      showDelete: false
    },
    {
      id: "3", label: "Pilote", permissions: [
        { id: "1", label: "Ajouter Institution" },
        { id: "2", label: "Modifier Produit" },
        { id: "2", label: "Supprimer Institution" }
      ],
      showDelete: false
    }
  ]

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const states = useSelector((state) => state, shallowEqual);

  // To populate the breadcrumb and update the sidebar menu
  useEffect(async () => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Roles", secondLevelLink: "/role", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("settings", dispatch, states);
    handleSubMenuSelection("roles", dispatch)
  }, [])

  // Load Roles
  useEffect(async () => {
    let role_list_response = await getRoles(states.userToken.access_token);
    let role_list_response_copy = role_list_response.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    console.log(role_list_response_copy)
    dispatch({
      type: "SET",
      key: "roleList",
      payload: role_list_response_copy,
    });
    setDisplayLoader(false);
  }, [])

  //   Go to new role screen
  const handleGoToNewRoleScreen = () => {
    navigate("/role/new")
  };

  //   Close Delete Confirmation Popup
  const handleCloseDeleteModal = (id) => {
    let index = states.roleList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.roleList];
    newTableData[index].showDelete = false;

    dispatch({
      type: "SET",
      key: "roleList",
      payload: newTableData,
    });
  };

  //   Show Delete Confirmation Popup
  const handleShowDeleteModal = (id) => {
    let index = states.roleList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.roleList];
    newTableData[index].showDelete = true;
    dispatch({
      type: "SET",
      key: "roleList",
      payload: newTableData,
    });
  };

  //   To make research

  const [search, setSearch] = useState("");
  const handleSearchChange = (e) => {
    console.log(e.currentTarget.value)
    setSearch(e.currentTarget.value)

  }



  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            {/* Start Core */}
            <h2 className="mb-3 text-left">Liste des rôles</h2>
            {displayLoader == false ?
            <div className="widget widget-content widget-content-area">
              <div className="dataTables_wrapper  dt-bootsrap4">
                <div className="dt--top-section container-fluid my-4 pt-3 px-3">
                  <div className="row">
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center">
                      <form class="form-inline justify-content-center search-input-container mb-3">
                        <div class="w-100 d-flex flex-nowrap search-input-container">
                          <input type="text" onChange={handleSearchChange} class=" form-control product-search br-30" id="input-search" placeholder="Rechercher..." />

                        </div>
                      </form>
                    </div>
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center mt-sm-0 mt-3">
                     {states.userPermissions?.create_role !== undefined && <div>
                        <button className="btn btn-info mb-2" onClick={() => handleGoToNewRoleScreen()}> <BiPlusMedical className="" /> Ajouter</button>
                      </div>}
                    </div>
                  </div>
                </div>
                {states.roleList && searchFunction(states.roleList, search).length != 0 ? <CustomDatatableRole columns={tableColumns}
                  data={searchFunction(states.roleList, search).sort()}
                  handleCloseDeleteModal={handleCloseDeleteModal}
                  handleShowDeleteModal={handleShowDeleteModal}
                /> : <h4 className="mt-3">Aucun résultat</h4>}
              </div>
            </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}

            {/* End Core */}
          </div>

        </div>
      </div>
    </div>
  )
}

export default RoleList